import {Component, Inject, OnInit} from '@angular/core';
import {toggleTypes} from '@shared/components/check-box-map/check-box-map.component';
import {ModuleLayerIconMapping, moduleLayersMapping} from '@main/adc/adc-data';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {selectUserId} from '@core/states/user.state';
import {filter, take} from 'rxjs/operators';
import {IMapItem} from '@shared/interfaces/check-box';
import {AbgService} from '@main/adc/adc.service';
import {selectFilters} from '@main/adc/adc-store';

@Component({
    selector: 'oct-layer-settings-dialog',
    templateUrl: './layer-settings-dialog.component.html',
    styleUrls: ['./layer-settings-dialog.component.scss']
})
export class LayerSettingsDialogComponent implements OnInit {
    public disableApply = true;
    public showAll = false;
    public groupedData: any = {};
    public groupsNames: string[];
    public groupsSubNames = {};
    public type: toggleTypes = toggleTypes.icon;
    public toggleType = toggleTypes;
    public displayData;
    public groupBy = 'group';
    public moduleLayerIconMapping = ModuleLayerIconMapping;
    private flatFilters = [];
    private userId: number;
    private content;

    constructor(
        public dialogRef: MatDialogRef<LayerSettingsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private store: Store<any>,
        private abgService: AbgService
    ) {
    }

    ngOnInit() {
        this.store
            .pipe(
                select(selectUserId),
                filter(id => !!id),
                take(1),
            )
            .subscribe(userId => {
                this.userId = userId;
                this.loadFilters();
            });
    }

    onApplyFilter() {
        localStorage.setItem(`userAdcFilters_${this.data.source}_${this.userId}`, JSON.stringify(this.content));
        localStorage.setItem(`userAdcFilters_${this.data.source}_${this.userId}_AllLayers`, this.showAll.toString());
        this.abgService.updateLayerSetting$.next(true);
        this.abgService.updateSystemLayerContext(this.data.source, this.content);
        this.dialogRef.close(this.content);
    }

    checkAll() {
        if (!this.content?.length) {
            this.showAll = false;
            this.disableApply = true;
            return;
        }

        this.showAll = !this.content.find(a => !a.checked);
        this.disableApply = !this.flatFilters.find(a => a.checked);
    }

    flat(filters) {
        this.flatFilters = [];
        filters.forEach(a => {
            if (!a.items.length) {
                this.flatFilters.push(a);
            }
            a.items.forEach(item => {
                this.flatFilters.push(item);
            });
        });
    }

    onCheckAll(e: any) {
        this.showAll = e.target.checked;
        this.flatFilters.forEach(item => item.checked = this.showAll);
        this.groupData(this.content);
        this.checkAll();
    }

    onCheckAllGroupItems(groupItem: any, e: any) {
        groupItem.checked = e.target.checked;
        groupItem.items.forEach((item: IMapItem) => item.checked = groupItem.checked);
        this.checkAll();
    }

    onItemCheck(item, groupItem: any) {
        item.checked = !item.checked;

        const checkedLayers = groupItem.items.filter(layer => layer.checked);
        if (checkedLayers.length === groupItem.items.length) {
            groupItem.checked = true;
        } else {
            groupItem.checked = false;
        }
        this.checkAll();
    }

    private loadFilters() {
        const storageFilter = localStorage.getItem(`userAdcFilters_${this.data.source}_${this.userId}`);
        const allLayersFlag = JSON.parse(localStorage.getItem(`userAdcFilters_${this.data.source}_${this.userId}_AllLayers`));
        this.showAll = allLayersFlag != null ? allLayersFlag : true;

        if (storageFilter) {
            this.content = JSON.parse(storageFilter);
            this.flat(this.content);
            this.groupData(this.content);
            this.checkAll();
            return;
        }

        this.store
            .pipe(
                select(selectFilters(this.data.source)),
                filter((adcFilters: Array<any>) => !!adcFilters?.length),
                take(1),
            )
            .subscribe((adcFilters: Array<any>) => {
                this.content = adcFilters;
                this.flat(this.content);
                this.groupData(this.content);
                this.checkAll();
            });
    }

    private groupData(data) {
        this.groupedData = [];
        data.forEach((mapItem: IMapItem) => {
            if (!this.groupedData.hasOwnProperty(mapItem.group)) {
                this.groupedData[mapItem.group] = [];
            }
            this.groupedData[mapItem.group].push(mapItem);
        });

        this.groupsNames = Object.keys(this.groupedData);

        this.groupsNames.forEach(key => {
            const groupDataItems = this.groupedData[key];

            groupDataItems.forEach(groupItem => {
                groupItem.checked = groupItem.items.length ? !groupItem.items.find((item: IMapItem) => !item.checked) : groupItem.checked;
            });
        });

        this.groupsNames.forEach(groupName => {
            this.groupsSubNames[groupName] = moduleLayersMapping[groupName]?.length === 1 ? moduleLayersMapping[groupName][0] : '';
        });

        this.displayData = data;
    }
}
